import { cva } from 'class-variance-authority'

import { Sentiment } from '@/components/lemmala-design-system/variance-percentage/types'

export const deltaInkVariants = cva('', {
  variants: {
    sentiment: {
      [Sentiment.POSITIVE]: 'text-main-foreground-success',
      [Sentiment.NEGATIVE]: 'text-main-foreground-danger',
      [Sentiment.NEUTRAL]: 'text-main-foreground-primary',
    },
  },
  defaultVariants: {
    sentiment: Sentiment.NEUTRAL,
  },
})
